import { ModalCustom } from "components/ModalCustom";
import { ContainerTextos, Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  qtdAlteradosAutomaticamente: number;
  qtdAcaoNecessaria: number;
  qtdSucesso: number;
}

export function ModalDadosTabelaAcaoNecessaria({
  show,
  handleClose,
  qtdAcaoNecessaria,
  qtdAlteradosAutomaticamente,
  qtdSucesso,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Avaliação tipo e marca/modelo"
      centered={true}
      footer={true}
      footerCloseButton={true}
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>

        {qtdAcaoNecessaria > 0 && (
          <ContainerTextos>
            Será necessário alterar tipo ou marca/modelo de{" "}
            <strong>
              {qtdAcaoNecessaria} veículo{qtdAcaoNecessaria > 1 ? "s" : ""}
            </strong>{" "}
            para atender o padrão da FIPE.
          </ContainerTextos>
        )}
        {qtdAlteradosAutomaticamente > 0 && (
          <ContainerTextos>
            {qtdAlteradosAutomaticamente > 1 ? "Foram alterados " : "Foi alterado "}
            <strong>
              {qtdAlteradosAutomaticamente} veículo
              {qtdAlteradosAutomaticamente > 1 ? "s" : ""}
            </strong>{" "}
            automaticamente para atender o padrão de tipo ou marca/modelo da
            FIPE.
          </ContainerTextos>
        )}
        {qtdSucesso > 0 && (
          <ContainerTextos>
            Nenhum problema encontrado em tipo e marca/modelo para{" "}
            <strong>
              {qtdSucesso} veículo{qtdSucesso > 1 ? "s" : ""}
            </strong>
            .
          </ContainerTextos>
        )}
      </ModalBody>
    </ModalCustom>
  );
}
